exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner--blog{height:700px}.banner--blog .heading-1{max-width:500px;text-align:center;font-size:30px}.banner--blog .heading-3{font-size:18px}@media screen and (max-width:1023px){.banner--blog{text-align:center}.banner--blog .left,.banner--blog .right{height:50%}}@media (min-width:1024px){.banner--blog .lg\\:ml-0{margin-left:0!important}.banner--blog .heading-1{margin-right:auto;text-align:left;font-size:45px}.banner--blog .heading-3{font-size:25px}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};